import { z } from 'zod'

export const columns = [
  {
    id: 'username',
    label: 'User ID',
    width: '150px',
  },
  {
    id: 'name',
    label: 'User name',
    width: '150px',
  },
  {
    id: 'entityName',
    label: 'Entity name',
    width: '150px',
  },
  {
    id: 'taxDeductionAccountNumber',
    label: 'Entity TAN',
    width: '150px',
  },
  {
    id: 'assignedBy',
    label: 'Assigned by',
    width: '150px',
  },
  {
    id: 'assignedDate',
    label: 'Assigned date',
    width: '160px',
  },
  {
    id: 'updatedBy',
    label: 'Updated by',
    width: '150px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '150px',
  },
]

// Validation for yyyymmdd date format
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )


export const searchFields = [
  ...columns
    .filter(col => col.id !== 'name')
    .map(col => {
      if (col.id === 'assignedDate' || col.id === 'lastModifiedDate') {
        return {
          ...col,
          type: 'text',
          placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
          zod: ddMMyyyyListZod,
        }
      }
      return {
        id: col.id,
        label: col.label,
        type: col.type || 'text',
        placeholder: `Enter ${col.label}`,
      }
    }),
]
